import styled from 'styled-components'
import SelectSearch, {
  SelectSearchOption,
  SelectedOption,
} from 'react-select-search'
import 'react-select-search/style.css'
import stationsdata from './stationsList.json'
import { useEffect, useState } from 'react'
// import VirtualizedSelect from 'react-virtualized-select'
// import Select, { StylesConfig } from 'react-select'

import './overwrite.css'



export const StationSelect = ({
  onChange,
  current,
  isFullscreen = false,
  locales,
}: {
  onChange?: (e: StationSelectReturn) => void
  current?: string
  isFullscreen?: boolean
  locales?: { label: string; placeholder: string }
}) => {
  const [selectedID, setSelectedID] = useState<string | undefined>(current)
  const [selectedOption, setSelected] = useState<{
    label: string
    value: string
  }>()
  const options = stationsdata.map((m) => ({ name: m.n, value: m.i }))
  const optionsmap: { [key: string]: StationSelectReturn } = Object.fromEntries(
    stationsdata.map((m) => [m.i, { name: m.n, pos: m.p, id: m.i }])
  )

  useEffect(() => {
    onChange && onChange(optionsmap[selectedID as string])
    setSelected(
      stationsdata
        .map((m) => ({ label: m.n, value: m.i }))
        .find((m) => m.value === selectedID)
    )
  }, [selectedID])

  return (
    <StationSelectRoot
      className='StationSelectRoot'
      isFullscreen={isFullscreen}
    >
      {locales.label && <InputLabel>{locales.label}</InputLabel>}
      <SelectContainer>
        {/* <Select
          value={selectedOption}
          classNames={{
            option: (state) => 'option',
            control: (state) => 'control',
            menuList: (state) => 'menuList',
            indicatorsContainer: (state) => 'indicatorsContainer',
            container: (state) => 'container',
            valueContainer: (state) => 'valueContainer',
            placeholder: (state) => 'placeholder',
          }}
          formatOptionLabel={(option) => {
            return option.label.split('||')[0]
          }}
          
          placeholder='Startbahnhof auswählen'
          isSearchable={true}
   
          onChange={(e) => {
            setSelected(e)
            setSelectedID(e?.value)
          }}
          options={stationsdata.map((m) => ({ label: m.n, value: m.i }))}
        /> */}
        <SelectSearch
          options={options
            .map((m) => ({ ...m, index: Math.random() }))
            .sort((a, b) => (a.name > b.name ? 1 : -1))}
          value={selectedID}
          placeholder={locales.placeholder || 'Bahnhof auswählen'}
          search
          filterOptions={[
            (options: SelectSearchOption[], query: string) => {
              return options
                .map((m) => ({ ...m, index: Math.random() }))
                .filter((f) =>
                  f.name.toLowerCase().includes(query.toLowerCase())
                )
                .sort((a, b) =>
                  query
                    ? a.name.toLowerCase().replace(query.toLowerCase(), '')
                        .length -
                      b.name.toLowerCase().replace(query.toLowerCase(), '')
                        .length
                    : a.name.localeCompare(b.name)
                ) as SelectSearchOption[]
            },
          ]}
          autoComplete='on'
          renderValue={(valueProps) => {
            let betterProps = {
              ...valueProps,
              tabIndex: 0,
              value: valueProps.value?.split('||')[0],
            }
            return <SelectInput {...(betterProps as any)} />
          }}
          renderOption={(option, a) => {
            return (
              <SelectOption
                onClick={(e) => {
                  setSelectedID(option.value)
                  option.onMouseDown(e as any)
                }}
              >
                {a.name.split('||')[0]}
              </SelectOption>
            )
          }}
        />
        <FoldIcon />
      </SelectContainer>
    </StationSelectRoot>
  )
}
const CustomValueContainer = (props) => {
  const { children } = props

  let val = props.getValue()[0]
  return <div className='valueContainer'>{children}</div>
}
const CustomInput = (props) => {
  let val = props.getValue()[0] || { label: '' }
  return (
    <input
      // {...props}
      className='input'
      value={val.label.split('||')[0]}
    ></input>
  )
}
const CustomSingleValue = (props) => {
  const { children } = props
  console.log('CustomSingleValue', props)

  return <div className='singleValue'>{children.split('||')[0]}</div>
}
const CustomPlaceholder = (props) => {
  const { innerProps } = props

  return (
    <div className='placeholder' {...innerProps}>
      AAA
    </div>
  )
}
const CustomOption = (props) => {
  const { innerProps } = props
  return (
    <div className='option' {...innerProps}>
      {props.data.label.split('||')[0]}
    </div>
  )
}
const SelectContainer = styled.div`
  position: relative;
  *[aria-live],
  span {
    display: none;
  }
  /*  */
  .menuList {
    border: 1px solid #eee;
    top: 60px;
    position: absolute;
    background-color: #fff;
    max-height: 300px;
    width: 100%;
    overflow-y: scroll;
  }
`
const InputLabel = styled.div`
  font-size: 15px;
  opacity: 0.75;
`

const SelectInput = styled.input`
  border: 0;
  background-color: transparent;
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 15px;
  border: 3px solid #f00 !important;
  background-color: var(--site-background);
`
const SelectOption = styled.button`
  border: 0;
  background-color: transparent;
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 15px;
`
const FoldIcon = () => (
  <IconSVg
    version='1.1'
    x='0px'
    y='0px'
    viewBox='-10 0 60 35'
    style={{ right: '25px', pointerEvents: 'none' }}
  >
    <path
      d='M0,9.3L9.1,0L25,16.4L40.9,0L50,9.3L25,35L0,9.3z'
      fill='var(--brandblue-bright-3)'
    />
  </IconSVg>
)

const IconSVg = styled.svg`
  position: absolute;

  top: 50%;
  transform: translateY(-50%);
  z-index: 400;
  max-width: 22px;
`

const StationSelectRoot = styled.div.attrs({ className: 'StationSelectRoot' })<{
  isFullscreen: boolean
}>`
  pointer-events: all;
  padding: 0;
  position: relative;
  margin-bottom: 25px;
  width: 100%;
  /* max-width: 300px; */
  margin-bottom: 10px;
  display: inline-block;
  z-index: 400;
  background-color: var(--site-background);
  padding: 10px;
  @media screen and (max-width: 711px) {
    max-width: ${(props) =>
      props.isFullscreen ? 'calc(100% - 90px)' : 'calc(100% - 20px)'};
    /* width:calc(100% - 70px); */

    margin-left: ${(props) => (props.isFullscreen ? '20px' : undefined)};
    /* width: ${(props) =>
      props.isFullscreen ? 'calc(100% - 20px);' : 'calc(100% - 20px)'}; */
    margin-bottom: 0px;
  }
  :root {
    --select-search-selected: #f00;
  }
  .select-search-select {
    top: 48px !important;
    border: 1px solid var(--brandblue-main);

    border-color: rgba(150, 150, 150, 0.3) !important;
    background-color: var(--site-background);
    color: var(--text-color);
    ::-webkit-scrollbar {
      display: none;
    }
    ul {
      margin: 0;
      li {
        padding: 0px;
        border-bottom: 1px solid rgba(150, 150, 150, 0.3);
      }
    }
  }
  .select-search-container {
    width: 100%;

    @media screen and (max-width: 711px) {
      width: calc(100%);
    }
  }
  .select-search-select .select-search-options {
    padding-left: 0;

    button {
      background-color: var(--site-background);
      color: var(--text-color);
      padding: 15px;
      &:hover {
        cursor: pointer !important;
        background-color: rgba(150, 150, 150, 0.25);
      }
      &.select-search-is-selected {
        background-color: var(--brandblue-bright-5);
      }
    }
  }
`
